// registerScreenMappers.ts

import { ScreenMapperRegistry } from "./ScreenMapperRegistry";
import { StateStore } from "../../app/state/StateStore";
import { NoticeScreenMapper } from "./NoticeScreenMapper";
import { KrokScreenMapper } from "./KrokScreenMapper";
import { AuthScreenMapper } from "./AuthScreenMapper";
import { SubscribeAuthScreenMapper } from "./SubscribeAuthScreenMapper";
import { OtpScreenMapper } from "./OtpScreenMapper";
import { AccountScreenMapper } from "./AccountScreenMapper";
import { SubscriptionsScreenMapper } from "./SubscriptionsScreenMapper";
import { ChangeSubscriptionsScreenMapper } from "./ChangeSubscriptionsScreenMapper";
import { ConfirmCancelSubscriptionScreenMapper } from "./ConfirmCancelSubscriptionScreenMapper";
import { ConfirmChangeScreenMapper } from "./ConfirmChangeScreenMapper";
import { ListScreenMapper } from "./ListScreenMapper";

export function registerScreenMappers(
    registry: ScreenMapperRegistry,
    store: StateStore
): void {

    registry.register(
        new KrokScreenMapper(store)
    );

    registry.register(
        new NoticeScreenMapper(store)
    );

    registry.register(
        new AuthScreenMapper(store)
    );

    registry.register(
        new SubscribeAuthScreenMapper(store)
    );

    registry.register(
        new OtpScreenMapper(store)
    );

    registry.register(
        new AccountScreenMapper(store)
    );

    registry.register(
    new SubscriptionsScreenMapper(store)
    );

    registry.register(
        new ChangeSubscriptionsScreenMapper(store)
    );

    registry.register(
        new ConfirmCancelSubscriptionScreenMapper(store)
    );

    registry.register(
        new ConfirmChangeScreenMapper(store)
    );
    
    registry.register(
        new ListScreenMapper(store)
    );

}